"use client";

import { usePathname } from "next/navigation";

export default function AuthLayoutWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isLogin = pathname === "/login";

  if (isLogin) {
    return (
      <div className="min-h-dvh bg-background overflow-y-auto overflow-x-hidden">
        {children}
      </div>
    );
  }

  return (
    <div className="min-h-dvh flex items-center justify-center bg-background overflow-y-auto overflow-x-hidden">
      <div className="w-full max-w-md sm:max-w-lg md:max-w-xl flex items-center justify-center p-4 py-5 sm:p-10 min-h-0 shrink-0">
        <div className="w-full sm:backdrop-blur-xl sm:bg-card/90 sm:rounded-[2.5rem] sm:border-2 sm:border-border/70 sm:shadow-lg sm:p-10 md:p-12 lg:p-14">
          {children}
        </div>
      </div>
    </div>
  );
}
